export default "__VITE_ASSET__u_3v$t_U__"